<script lang="ts">
  import { untrack } from "svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import {
    fetchHomeDashboard,
    type HomeDashboardResponse,
  } from "../../../../../../../../api/kehrblatt/home-dashboard"
  import { currentWeekRange } from "../../../../_shared/_logic/home-dashboard"
  import PlanningCharts from "./_modules/planning-charts"

  const { organizationId } = $props<{ organizationId: string }>()
  let response = $state<{ organizationId: string; data: HomeDashboardResponse } | null>(null)
  let failedOrganizationId = $state<string | null>(null)
  let retry = $state(0)
  const statistics = $derived(
    response?.organizationId === organizationId ? response.data.statistics : null,
  )
  const failed = $derived(failedOrganizationId === organizationId || statistics?.state === "ERROR")

  $effect(() => {
    const requestedOrganizationId = organizationId
    retry
    const request = new AbortController()
    untrack(() => {
      failedOrganizationId = null
    })
    void fetchHomeDashboard(requestedOrganizationId, currentWeekRange(), {
      signal: request.signal,
    }).then(
      (data) => {
        if (!request.signal.aborted) response = { organizationId: requestedOrganizationId, data }
      },
      () => {
        if (!request.signal.aborted) failedOrganizationId = requestedOrganizationId
      },
    )

    return () => request.abort()
  })
</script>

<section aria-label="Termin- und Auftragsstatistiken">
  {#if failed}
    <div class="statistics-error" role="alert">
      <span>Die Termin- und Auftragsstatistiken konnten nicht geladen werden.</span>
      <CTA
        type="secondaryButton"
        small={true}
        content="Erneut laden"
        darkMode={false}
        onClick={() => (retry += 1)}
      />
    </div>
  {/if}
  {#if statistics?.state === "READY" && statistics.data}
    <PlanningCharts
      communicationPoints={statistics.data.communication_points}
      workOrderStatusShare={statistics.data.work_order_status_share}
    />
  {:else if !failed && !statistics}
    <p role="status">Termin- und Auftragsstatistiken werden geladen …</p>
  {/if}
</section>

<style>
  .statistics-error {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 1rem;
    border: 1px solid color-mix(in srgb, var(--warning-100, #e07a00) 40%, transparent);
    color: var(--text-invers-100);
  }
</style>
